import React from "react";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./functions/callBackFunctions";
import $ from "jquery";
import * as CommonFunctions from "../common/commonFunctions";
import ColumnList from "../../../../common/componet-jsons/column-list-catalog.json";
import * as GC from "../../../../common/common";
import {CONSTS} from "../../../../common/const";
import {GetSelected} from "../../../../common/tableHandler/manipulateTable";
import {GetAllBySearchAction} from "../../../../../api/omnimap/omnimapActions";
import {fillDetailOrganization} from "../common/commonFunctions";
import {sleep} from "../../../../common/common";

class Table extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            columnList: [],
            columnListPure: [],
            columnOrderIdentification: "",
            columnOrderReference: "",
        };
    }

    reloadData(page_number, ids, short_type, direction, field, content = []) {
        let model;

        this.fillTable((model = []), (page_number = 1));
        this.fillFilterColumns();
    }

    fillFilterColumns() {
        // omnimap
        //     .GetUserRolesAction(1, 100, window.$catalog_users_organizations_token)
        //     .then((result) => {
        //         CallBackFunctions.FillFilterColumnsCallBack(
        //             "user-gebruikersrollen",
        //             result
        //         );
        //     });
        // var that = this;
        // var model = {
        //   definitions: [process.env.REACT_APP_CATALOG_M_UNITS],
        // };
        // $.each(window.$catalog_users_organizations_columnList, function (index, data) {
        //   if (data.id !== "" && data.filter === true) {
        //     omnimap
        //       .FillFilterColumnsAction(model, data.id, window.$catalog_users_organizations_token)
        //       .then((result) => {
        //         CallBackFunctions.FillFilterColumnsCallBack(data, result);
        //       })
        //       .catch((error) => {
        //         console.log(error);
        //       });
        //   }
        // });
    }

    fillTable(model, page_number) {
        window.$catalog_users_organizations_lastUsedTableFilter = model;

        window.$catalog_users_organizations_treeChangeStatus = false;
        window.$catalog_users_organizations_scroll_change = false;

        model = {
            "content": [],
            "context": [],
            "definitions": [
                "84a38236-5bdb-477e-b506-3c0ea2cb7f65"
            ],
            "statuses": []
        }
        omnimap
            .GetAllBySearchAction(model, 100, page_number)
            .then((result) => {
                CallBackFunctions.FillTableCallBack(
                    result,
                    page_number,
                    window.$catalog_users_columnListPure
                );
            });
    }

    addContentAndFillTable(key, value) {
        const hasRow = $.grep(
            window.$catalog_users_organizations_filterContent,
            function (v) {
                return v.key === key;
            }
        );
        /*var hasRow = window.$catalog_users_organizations_filterContent.filter(
          (v) => v.key === key
        );*/

        if (hasRow.length > 0) {
            window.$catalog_users_organizations_filterContent = $.grep(
                window.$catalog_users_organizations_filterContent,
                function (value) {
                    return value !== hasRow[0];
                }
            );
        }
        if (value !== null) {
            const contentModel = {
                key: key,
                value: value,
            };
            window.$catalog_users_organizations_filterContent.push(contentModel);
        }

        /**
         * *omnimap'teki yapıya göre username ve email aynı alanda arama yapılıyor
         * * bu yüzden ya username yada email araması yapılması gerekiyor
         */
        // if (
        //     window.$catalog_users_organizations_filterContent.length > 0 &&
        //     key !== "user-gebruikersrollen" &&
        //     key !== "user-organisatie"
        // ) {
        //     const test = window.$catalog_users_organizations_filterContent.filter(
        //         (x) => x.key !== key
        //     );
        //     if (test.length > 0) {
        //         // burada username yada email alanlarından sadece birtanesi seçilmesi zorunluğu sağlanıyor.
        //         document.getElementById(test[test.length - 1].key).value = "";
        //     }
        // }

        // let role = window.$catalog_users_organizations_filterContent.find(
        //     (x) => x.key === "user-gebruikersrollen"
        // );
        // let organisatie = window.$catalog_users_organizations_filterContent.find(
        //     (x) => x.key === "user-organisatie"
        // );
        // //only name and email filter
        // let filter = window.$catalog_users_organizations_filterContent.find(
        //     (x) => x.key !== "user-gebruikersrollen" && x.key !== "user-organisatie"
        // );
        // omnimap
        //     .GetAllUsersAction(
        //         1,
        //         100,
        //         filter && true ? filter.value : "",
        //         organisatie && true ? organisatie.value : "",
        //         "",
        //         role && true ? role.value : "",
        //         window.$catalog_users_organizations_token
        //     )
        //     .then((result) => {
        //         CallBackFunctions.FillTableCallBack(result, 1, window.$catalog_users_organizations_columnListPure);
        //     });
    }

    searchFilterColumns(key, searchId) {
        if (searchId === "user-organisatie") {
            omnimap
                .GetOrganisationsAction(1, 100, window.$catalog_users_organizations_token)
                .then((result) => {
                    CallBackFunctions.SearchFilterColumnsCallBack(
                        "user-organisatie",
                        result
                    );
                });
        } else if (searchId === "user-gebruikersrollen") {
            omnimap
                .GetUserRolesAction(1, 100, window.$catalog_users_organizations_token)
                .then((result) => {
                    CallBackFunctions.SearchFilterColumnsCallBack(
                        "user-gebruikersrollen",
                        result
                    );
                });
        } else {
            omnimap
                .GetAllUsersAction(1, 100, key, "", "", "", window.$catalog_users_organizations_token)
                .then((result) => {
                    var unique = [];
                    if (searchId === "user-alias") {
                        /**
                         * * sql'deki gibi dizi içerisinde distinct mantığı ile
                         * * tekrar eden satırlar tekleştiriliyor.
                         */
                        unique = [
                            ...new Set(result.data && result.data.map((item) => item.alias)),
                        ];
                    } else if (searchId === "user-email") {
                        /**
                         * * sql'deki gibi dizi içerisinde distinct mantığı ile
                         * * tekrar eden satırlar tekleştiriliyor.
                         */
                        unique = [
                            ...new Set(result.data && result.data.map((item) => item.email)),
                        ];
                    }

                    CallBackFunctions.SearchFilterColumnsCallBack(searchId, unique);
                });
        }
    }

    GetActionsOfRow(rowIds) {
        CallBackFunctions.GetActionsOfRowCallback();
    }

    /*** ---PROPSTAN GELEN TREE VERİSİ İÇERİSİNDE TIKLANAN Lİ'NİN TÜM ALT DALLARINDAKİ İDLERİ GETİRİR--- ***/
    treeParser = (data, beheereenheid) => {
        const that = this;
        data.forEach(function (element) {
            if (element.parentfolder === beheereenheid) {
                window.$catalog_users_organizations_result.push(element.id);
                if (element.children.length > 0) {
                    that.treeParser(element.children, element.id);
                }
            } else if (element.children && element.children.length > 0) {
                that.treeParser(element.children, beheereenheid);
            }
        });
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        const that = this;
        if (!that.props.location.state) {
            if (that.props.location.isDidUpdate !== prevProps.location.isDidUpdate) {
                // that.setState({ lastUsedTableFilter: model });
                window.$catalog_users_organizations_lastUsedTableFilter = {
                    content: [],
                    definitions: [process.env.REACT_APP_CATALOG_M_UNITS],
                };

                that.reloadData(1);
                document.getElementById("tree-parent-id").setAttribute("value", "");

                var treeClass = document.querySelector(".tree li.open.act");
                var treeDivClass = document.querySelector(".tree li div.open.act");
                if (treeClass !== null) {
                    treeClass.removeAttribute("class");
                }
                if (treeDivClass !== null) {
                    treeDivClass.classList.remove("open");
                    treeDivClass.classList.remove("act");
                }
            } else {
                $("#cover-spin").hide(0);
            }
        } else if (that.props.location.state && prevProps.location.state) {
            if (
                that.props.location.state.isDidUpdate !==
                prevProps.location.state.isDidUpdate
            ) {
                if (that.props.location.state.isDidUpdate === "0038") {
                    /*var model = {
                        content: [],
                        definitions: [process.env.REACT_APP_CATALOG_M_UNITS],
                    };*/
                    // that.setState({ lastUsedTableFilter: model });
                    that.reloadData(1);
                } else {
                    window.$catalog_users_organizations_result = [];
                    window.$catalog_users_organizations_result.push(that.props.location.state.id);
                    this.treeParser(
                        that.props.location.state.TreeList,
                        that.props.location.state.id
                    );
                    if (that.props.location.state.treeLocation !== "modal") {
                        that.reloadData(1, window.$catalog_users_organizations_result);
                    }
                }
            }
                //* sayfa f5 ile yenilendiğinde prev props:
            //* temizlenmediğinden dolayı veri gelmemesi sorunu için bu kod çalıştırılıyor.
            else if (window.performance) {
                if (performance.navigation.type === 1) {
                    if (that.props.location.state.isDidUpdate === "0038") {
                        // var model = {
                        //     content: [],
                        //     definitions: [process.env.REACT_APP_CATALOG_M_UNITS],
                        // };
                        // that.setState({ lastUsedTableFilter: model });
                        that.reloadData(1);
                    } else {
                        window.$catalog_users_organizations_result = [];
                        window.$catalog_users_organizations_result.push(that.props.location.state.id);
                        this.treeParser(
                            that.props.location.state.TreeList,
                            that.props.location.state.id
                        );
                        if (that.props.location.state.treeLocation !== "modal") {
                            that.reloadData(1, window.$catalog_users_organizations_result);
                        }
                    }
                } else {
                    //alert("This page is not reloaded");
                }
            }
        } else {
            window.$catalog_users_organizations_result = [];
            window.$catalog_users_organizations_result.push(that.props.location.state.id);
            this.treeParser(
                that.props.location.state.TreeList,
                that.props.location.state.id
            );
            if (that.props.location.state.treeLocation !== "modal") {
                that.reloadData(1, window.$catalog_users_organizations_result);
            }
            $("#cover-spin").hide(0);
        }
    }
    componentWillMount() {
        $('#example2').DataTable().destroy();
    }

    async componentDidMount() {
        const that = this;
        const exampleTbody = $("#example2 tbody")
        const scrollableDatatableId = $("#scrollabe-datatable-id")
        window.$catalog_users_organizations_Glist = []
        /***************************************************************************************/
        /**FREE FORMAT */
        let tableHeaderItems;
        const userColumnResult = await omnimap.GetFreeFormatByIdAction(
            CONSTS.USER_ID_STORE
        );
        // userda column sort id'si varmı ?
        if (userColumnResult.meta.total_found === 0) {
            var user = window.localStorage.getItem("accessToken");
            window.$mm_management_units_column_order_users.client_identification =
                CONSTS.USER_ID_STORE;
            window.$mm_management_units_column_order_users.code =
                CONSTS.USER_ID_STORE;
            window.$mm_management_units_column_order_users.data.users.push({
                user_id: user.identification,
                id_stores: {
                    table_column_order: GC.uuidv4(),
                },
            });
            omnimap
                .GetFreeFormatAction(
                    "",
                    "POST",
                    window.$mm_management_units_column_order_users
                )
                .then(() => {
                    // GC.sleep(1500).then(() => this.fillTable());
                });
        }
        //userda column sort id'si var sa else geç
        else {
            let result = await omnimap.GetFreeFormatByIdAction(
                CONSTS.COLUMN_ORDER_CATALOG_USERS_ORGANIZATIONS
            );

            // bu sayfanın column sort'u var mı?
            if (result.meta.total_found === 0) {
                window.$catalog_users_organizations_column_order_post_model.client_identification =
                    CONSTS.COLUMN_ORDER_CATALOG_USERS_ORGANIZATIONS;
                window.$catalog_users_organizations_column_order_post_model.code =
                    CONSTS.COLUMN_ORDER_CATALOG_USERS_ORGANIZATIONS;

                omnimap
                    .GetFreeFormatAction(
                        "",
                        "POST",
                        window.$catalog_users_organizations_column_order_post_model
                    )
                    .then(() => {
                        window.location.reload();
                    });
            }
            // bu sayfanın column sort'u varsa else'e geç
            else {
                //burada sayfanın column sortları listenelinr ve table th sıralaması yapılır

                let result = await omnimap.GetFreeFormatByIdAction(
                    CONSTS.COLUMN_ORDER_CATALOG_USERS_ORGANIZATIONS,
                    "GET"
                );

                await this.setState({
                    columnOrderIdentification: result.data[0].identification,
                    columnOrderReference: result.data[0].reference,
                });

                result = await result.data[0].data.table_sorting.find(
                    (x) => x.name === "catalog>users>organizations"
                );

                tableHeaderItems = await result.column_list.map((item, index) =>
                    item === "checkbox" ? (
                        <th className="sorting_disabled">
                            <span className="checkAll"/>
                            <span className="checkNone" style={{display: "none"}}/>
                        </th>
                    ) : item === "active" ? (
                        <th className="sorting_disabled" style={{width: "1%"}}>
                            <div id="beheer-short-table">
                                <div id="beheer-svg" className="maatregelen-svg"/>
                                <div id="beheer-snowflake" className="snowflake"/>
                            </div>
                        </th>
                    ) : item === "isGeneralExecutor" ? (
                        <th>
                            Is uitvoerder
                        </th>
                    ) : (
                        <th key={item}>{item}</th>
                    )
                );
                await this.setState({
                    columnList: tableHeaderItems,
                });
                window.$catalog_users_organizations_columnListPure = result;
            }
        }
        /***************************************************************************************/

        if (window.$catalog_users_organizations_token == null) {
            window.$catalog_users_organizations_token = GC.GetToken().then((token) => {
                window.$catalog_users_organizations_token = token;
                this.reloadData(1);
            });
        } else that.reloadData(1);

        ColumnList.forEach(function (item) {
            if (item.name === "catalog>users") {
                window.$catalog_users_organizations_columnList = item["column-list"];
            }
        });
        const table = $("#example2").DataTable({
            order: [],
            ordering: true,
            orderCellsTop: true,
            fixedHeader: true,
            searching: false,
            paging: false,
            scrollX: true, //"500px",

            scrollCollapse: true,
            scrollY: "calc(100vh - 330px)",

            dom: '<"top"if>t<"bottom"pr><"clear">',
            info: true,
            destroy: true,
            infoCallback: function (settings, start, end, max, total, pre) {
                return (
                    '<span class="select-item"></span>' +
                    '<span class="total_right"><span id="total-rows" class="total">' +
                    end +
                    "</span> geselecteerd </span>"
                );
            },
            language: {
                paginate: {
                    previous: "Eerste",
                    next: "Laatste",
                },
                select: {
                    rows: '<span class="items">%d </span>items van&nbsp;', //'<span class="items">%d </span>items van&nbsp;',
                },
            },
            columnDefs: [
                {
                    targets: [0],
                    data: null,
                    defaultContent: "",
                    orderable: false,
                    className: "select-checkbox",
                },
            ],
            select: {
                style: "multi+shift",
                selector: "tr",
            },
            // Disable sorting on the sorting_disabled class
            aoColumnDefs: [
                {
                    bSortable: false,
                    aTargets: ["sorting_disabled"],
                },
            ],
            colReorder: {
                fixedColumnsLeft: 1
            },
            stateSave: true,
            stateSaveCallback: (settings, data) => {
                window.$catalog_users_organizations_columnListPure = CallBackFunctions.TableColumnChangeHandler(
                    settings,
                    data,
                    that.state.columnOrderIdentification,
                    that.state.columnOrderReference,
                    CONSTS.COLUMN_ORDER_CATALOG_USERS_ORGANIZATIONS
                );
            },
        });
        table.columns().iterator("column", function (ctx, idx) {
            if (
                window.$catalog_users_organizations_columnListPure.column_list[idx] === "checkbox" ||
                window.$catalog_users_organizations_columnListPure.column_list[idx] === "active"
            ) {
            } else {
                $(table.column(idx).header()).append('<span class="sort-icon"/>');
            }
        });
        const lastScrollLeft = 0;
        let lastScrollControl = 0.33;
        const buffer = 0.33; // # of pixels from bottom of scroll to fire your function. Can be 0

        $(".dataTables_scrollBody").scroll(function () {
            const dataTablesScrollBody = $(".dataTables_scrollBody")
            const documentScrollLeft = dataTablesScrollBody.scrollLeft();
            if (window.$catalog_users_organizations_scroll_change) {
                if (
                    dataTablesScrollBody.prop("scrollHeight") -
                    dataTablesScrollBody.scrollTop() <=
                    dataTablesScrollBody.height() + buffer
                ) {
                    lastScrollControl = 0;
                }
            }
            if (window.$catalog_users_organizations_scroll_change) {
                if (
                    dataTablesScrollBody.prop("scrollHeight") -
                    dataTablesScrollBody.scrollTop() <=
                    dataTablesScrollBody.height() + buffer
                ) {
                    lastScrollControl = 0;
                }
            }
            if (lastScrollLeft === documentScrollLeft + lastScrollControl) {
                if (window.$catalog_users_organizations_scroll_change) {
                    if (
                        dataTablesScrollBody.prop("scrollHeight") -
                        dataTablesScrollBody.scrollTop() <=
                        dataTablesScrollBody.height() + buffer
                    ) {
                        if (document.getElementById("tableSide").className !== "d-none") {
                            if (
                                `/${this.baseURI.split("/")[3]}/${
                                    this.baseURI.split("/")[4]
                                }` === that.props.location.pathname &&
                                window.$catalog_users_organizations_total_row > 100
                            ) {
                                $("#cover-spin").show(0);
                                window.$catalog_users_organizations_page_number++;
                                that.fillTable(
                                    window.$catalog_users_organizations_lastUsedTableFilter,
                                    window.$catalog_users_organizations_page_number
                                );
                            }
                        } else window.$catalog_users_organizations_scroll_change = true;
                    }
                }
            }
        });
        // $(document).on("click", "#mappen_beheren", function () {
        //     $("#mappen_beheren_modal").modal("show");
        // });
        // $(document).on("click", "#user-verwijderen", function () {
        //     if (window.$catalog_users_organizations_selectedIds === 0) {
        //         alert("rows not selected");
        //     } else {
        //         $("#user-delete-modal").modal("show");
        //     }
        // });

        /*** SETUP - ADD A TEXT INPUT TO EACH FOOTER CELL ***/
        $("#example2 thead tr").clone(true).appendTo("#example2 thead");
        $("#example2 thead tr th").removeClass("sorting_asc");

        $(table.table().header()).addClass("scrollabe-datatable");

        document.getElementsByClassName("scrollabe-datatable")[0].parentElement.id =
            "scrollabe-datatable-id";

        $("#scrollabe-datatable-id thead tr")
            .clone(true)
            .appendTo("#scrollabe-datatable-id thead");

        $("#scrollabe-datatable-id thead tr:eq(1) th").each(function (i) {
            const title = $(this).text();
            if (title) {
                // Use here to enable search on column
                /*const row = $.grep(window.$catalog_users_organizations_columnList, function (v) {
                    return String(v.name).toLowerCase() === String(title).toLowerCase();
                });
                const rowId = row[0].id;
                if (row[0].filter === true) {
                    $(this).html(
                        '<input type="search" class="col-search" id="' + rowId + '" />'
                    );
                    $("input", this).on("keyup change", function () {
                        if (table.column(i).search() !== this.value) {
                            table.column(i).search(this.value).draw();
                        }
                    });
                } else {
                    $(this).html("");
                }*/
                $(this).html("");
            } else if (this.innerHTML.includes("checkAll")) {
                //$(this).html( '<div class="popup threedots" onclick="Popup()"><span class="popuptext" id="myPopup"><a class="maatregelen" href="#">Maatregelen</a><a class="locate" href="#">Beheer gebieden</a><a class="map" href="#">Toon op kaart</a><a class="trash-bin" href="#">Verwijderen</a></span></div>' );
                $(this).html(
                    '<div class="popup threedots"><span class="popuptext" id="myPopup"></span></div>'
                );
            } else if (this.innerHTML.includes("snowflake")) {
                $(this).html(
                    '<div class="refresh"> </div>' +
                    /**popup filter1 */
                    '<div class="filter-popup">' +
                    '  <span class="popuptext" id="beheer-short-table-popup" ></span>' +
                    "</div>"
                );
            } else {
                $(this).html("");
            }
        });

        exampleTbody.on("click", "tr", function () {
            if ($(".checkAll").attr("style") === "display: none;") {
                $(".checkNone, .checkAll").toggle();
            }
        });

        //** select all table
        scrollableDatatableId.on("click", ".checkAll", function () {
            const table = $("#example2").DataTable();
            table.rows().select();

            $(".checkNone, .checkAll").toggle();
        });

        //** unselect all table
        scrollableDatatableId.on("click", ".checkNone", function () {
            const table = $("#example2").DataTable();

            table.rows().deselect();
            $(".checkNone, .checkAll").toggle();
        });

        $("#example_filter input").addClass("search-input-table1");
        $(".search-input-table1").attr("placeholder", "search text");

        //Double Click
        exampleTbody.on("dblclick", "tr", function () {
            const rowId = $(this).attr("rowId");
            const item  = window.$catalog_users_organizations_Glist.find(item => item.identification === rowId);

            CommonFunctions.fillDetailOrganization(item);
            $("#tableSide").addClass("d-none");
            const detailSide = $("#organisatie-detail");
            detailSide.removeClass("d-none");
            detailSide.attr("name", "dbl");
        });

        /*** ---OPTION TO ALLOW SELECTING ROWS BY CLICKING ON ROW BESIDES CHECKBOX--- ***/
        // $("#example tbody").on("click", "tr", function () {
        //   $(this).toggleClass("selected");
        // });

        // $("#user-alias").autocomplete({
        //     source: window.$catalog_users_organizations_user_alias,
        //     select: function (event, ui) {
        //         that.addContentAndFillTable("user-alias", ui.item.value);
        //     },
        //     open: function (e, ui) {
        //         $(".ui-autocomplete").css(
        //             "top",
        //             $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        //         );
        //     },
        // });
        // $("#user-email").autocomplete({
        //     source: window.$catalog_users_organizations_user_email,
        //     select: function (event, ui) {
        //         that.addContentAndFillTable("user-email", ui.item.value);
        //     },
        //     open: function (e, ui) {
        //         $(".ui-autocomplete").css(
        //             "top",
        //             $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        //         );
        //     },
        // });
        // $("#user-gebruikersrollen").autocomplete({
        //     source: window.$catalog_users_organizations_gebruikersrollen,
        //     select: function (event, ui) {
        //         that.addContentAndFillTable("user-gebruikersrollen", ui.item.value);
        //     },
        //     open: function (e, ui) {
        //         $(".ui-autocomplete").css(
        //             "top",
        //             $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        //         );
        //     },
        // });
        // $("#user-organisatie").autocomplete({
        //     source: window.$catalog_users_organizations_organisatie,
        //     select: function (event, ui) {
        //         that.addContentAndFillTable("user-organisatie", ui.item.value);
        //     },
        //     open: function (e, ui) {
        //         $(".ui-autocomplete").css(
        //             "top",
        //             $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        //         );
        //     },
        // });

        // $("#user-alias").on("input", function () {
        //     // that.algemeenCode.length = 0;
        //     that.searchFilterColumns($(this).val(), this.id);
        //     // get the current value of the input field.
        // });
        // $("#user-email").on("input", function () {
        //     // that.algemeenCode.length = 0;
        //     that.searchFilterColumns($(this).val(), this.id);
        //     // get the current value of the input field.
        // });

        // $("#user-gebruikersrollen").on("input", function () {
        //     // that.algemeenCode.length = 0;
        //     that.searchFilterColumns($(this).val(), this.id);
        //     // get the current value of the input field.
        // });
        // $("#user-organisatie").on("input", function () {
        //     // that.algemeenCode.length = 0;
        //     that.searchFilterColumns($(this).val(), this.id);
        //     // get the current value of the input field.
        // });

        $(".col-search").on("input", function () {
            if (this.value === "") {
                // that.addContentAndFillTable($(this).attr("id"), null);
            }
        });

        /*  $(".col-search").on("click", function (e) {
            e.stopPropagation();
          });
          $(".col-search").keydown(function (e) {
            if (e.keyCode == 13) {
              e.preventDefault();
              return false;
            }
          });
      */
        function handleRefresh() {
            $("#cover-spin").show(0);
            $("#spinner").removeAttr("hidden");
            that.fillTable(window.$catalog_users_organizations_lastUsedTableFilter, 1);
            // that.reloadData(1);
        }

        window.$catalog_users_organizations_refresh = handleRefresh;

        $(".refresh").click(function (e) {
            e.stopPropagation();
            $("#cover-spin").show(0);
            $("#spinner").removeAttr("hidden");
            that.fillTable(window.$catalog_users_organizations_lastUsedTableFilter, 1);
            // that.reloadData(1);
        });

        $(".back-page-link").click(function () {
            $("#tableSide").removeClass("d-none");
            $("#organisatie-detail").addClass("d-none");
            $("#editSide").addClass("d-none");
        });
        $("#organization-edit-button").click(function () {
            $("#editSide").removeClass("d-none");
            $("#organisatie-detail").addClass("d-none");
        });
        $("#return-detail").click(function () {
            $("#organisatie-detail").removeClass("d-none");
            $("#editSide").addClass("d-none");
        });

        $("div.popup").click(function () {
            const selectedIds = GetSelected()
            // that.setState({ selectedIds: selectedIds });
            window.$catalog_users_organizations_selectedIds = selectedIds;
            that.GetActionsOfRow(selectedIds.join(","));
        });

        // $(document).on("click", "#verwijderen", function () {
        //     if (window.$catalog_users_organizations_selectedIds === 0) {
        //         alert("rows not selected");
        //     } else {
        //         $("#management-units-mappen_beheren_delete_modal").modal("show");
        //     }
        // });

        // function koppelAanFolderCallBack() {
        //     GC.sleep(2000).then(() => {
        //         $("#cover-spin").hide(0);
        //
        //         $("#modal_koppel_aan_folder").modal("hide");
        //         that.reloadData(1);
        //     });
        // }

        // $(document).on("click", "#management-units-koppel-aan-folder", () => {
        //     $("#cover-spin").show(0);
        //
        //     var model = {
        //         action: "ADD",
        //         contextRol: "Beheereenheid zit in folder",
        //         folder: document.getElementById("tree-parent-id").value,
        //     };
        //     GC.StartActivity(
        //         model,
        //         window.$catalog_users_organizations_selectedIds,
        //         "708371ee-e3f6-4de7-87f8-dfe94b86f9b1",
        //         koppelAanFolderCallBack(),
        //         window.$catalog_users_organizations_token
        //     );
        // });

        // $(document).on("click", ".mm_work_plans_action", function () {
        //     var actionId = $(this).attr("id");
        //     let modalId = window.$mm_work_plans_actions.filter(
        //         (act) => act["id"] === actionId
        //     )[0]["modal"];
        //     $("#" + modalId).modal("show");
        // });
    }

    render() {
        return (
            <div id="tableSide">
                <table id="example2" className="table-hover table min-full-width">
                    <thead>
                    <tr>
                        {this.state.columnList}
                    </tr>
                    </thead>
                    <tbody/>
                </table>
                <input id="tree-parent-id" hidden/>
                <input id="tree-parent-name" hidden/>
            </div>
        );
    }
}

export default Table;
